module.exports = __webpack_public_path__ + "img/36.07705f3c.jpg";